<template>
  <div class="text-black">
    <LinksBlock
      v-if="articleCategoriesFooterBlockData"
      class="px-0"
      :title="articleCategoriesFooterBlockData"
      :content="articleCategoriesFooterBlockData"
    />
  </div>
</template>

<script lang="ts" setup>
import type { StrapiMagazineArticleCategory } from '~/composables/types/strapi/strapi-magazine'
const fullLocalizedUrl = useFullLocalizedUrl()
const { t } = useI18n()

const { data } = await useStrapiArticleCategories()
const articleCategoriesFooterBlockData = computed(() => ({
  title: t('magazine.footerLinks.title'),
  items: data.value?.map((category: StrapiMagazineArticleCategory) => ({
    label: articleCategoryGetters.getTitle(category),
    imgUrl: null,
    link: fullLocalizedUrl(
      `/magazine/${articleCategoryGetters.getSlug(category)}`
    ),
  })),
}))
</script>
